import { useQuery } from "@tanstack/react-query";
import { apiClient } from "./client";
import type { ApiSuccessResponse } from "@erp/shared";

export interface HealthStatus {
  status: "healthy" | "degraded";
  checks: Record<string, "ok" | "error">;
  timestamp: string;
  uptimeSeconds: number;
}

export function useHealthCheck() {
  return useQuery({
    queryKey: ["health"],
    queryFn: async () => {
      const { data } = await apiClient.get<ApiSuccessResponse<HealthStatus>>("/health");
      return data.data;
    },
    refetchInterval: 15000,
  });
}
